
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';

const baseUrl = `${environment.apiBaseUrl}platform/teams`;
const secondUrl = `${environment.apiBaseUrl}platform`;
const exportUrl = `${environment.apiBaseUrl}platform/export`;

const headers = new HttpHeaders({
  'x-no-notification': 'true'
});

@Injectable({
  providedIn: 'root'
})
export class ExecutiveDashboardsService {
  constructor(private http: HttpClient) {}

  getTeams(): Observable<any> {
    return this.http.get<any>(`${baseUrl}/executive-teams`);
  }

  getTeamsData(teamId: string, widgetEnum: string, from: string, to?: string, selectedFilters?: any, sortedBy?: any, sortedOrder?: any, pageSize? :any,page? :any, searchByValues?: { dataType?: string; metricType?: string; viewType?: string }): Observable<any> {
    const body: any = {
      widgetEnum,
      teamId,
      from,
      to,
      page,
      pageSize,
      selectedFilters,
      sortedBy,
      sortedOrder,
    };


    if (widgetEnum === 'CODE_QUALITY_ISSUE_TYPES') {
      body.searchByValues = {
        metricType : searchByValues?.metricType,
        dataType : searchByValues?.dataType,
        viewType : searchByValues?.viewType,
      }
    }

    return this.http.post<any>(`${baseUrl}/executive-teams`, body, { headers });
  }

  exportData(teamId: string, widgetEnum: string, from: string, to?: string, selectedFilters?: any, sortedBy?: any, sortedOrder?: any, pageSize? :any,page? :any): Observable<HttpResponse<Blob>> {
    const body = {
      widgetEnum,
      teamId,
      from,
      to,
      page,
      pageSize,
      selectedFilters,
      sortedBy,
      sortedOrder,
    };
    return this.http.post(`${baseUrl}/executive-teams/export`, body, { responseType: 'blob', observe: 'response' });
  }

  getExportDataListByTeam(teamId: string, metricType?: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('teamId', teamId);
    params = params.append('metricType', metricType);
    return this.http.get(`${exportUrl}`, {params});
  }

  getComments(xAxisStart?: string,xAxisEnd?: string, teamId?: string, widgetType?: string): Observable<any> {
    return this.http.get<any[]>(`${baseUrl}/executive-teams/comments?xaxisStartDate=${xAxisStart}&xaxisEndDate=${xAxisEnd}&teamId=${teamId}&widgetType=${widgetType}`);
  }

  addComment( commenter:any  , xaxisStartDate:any ,xaxisEndDate:any, comment :any , teamId :any , widgetType:any, seriesName:any , relationCommentId :any): Observable<any> {
    const body = {
      commenter,
      xaxisStartDate,
      xaxisEndDate,
      comment,
      teamId,
      widgetType,
      seriesName,
      relationCommentId,
    };

    return this.http.post(`${baseUrl}/executive-teams/comments`, body);
  }

  updateComment(commentId: string, updatedComment: any) {
    return this.http.put(`${baseUrl}/executive-teams/comments/${commentId}`, updatedComment);
  }

  deleteComment(commentId: string) {
    return this.http.delete(`${baseUrl}/executive-teams/comments/${commentId}`);
  }

  getCoverageDetails(xAxisStart?: string,xAxisEnd?: string, page?: any, pageSize?:any, teamId?: string, widgetEnum?: string) {
    const params = {
      page,
      pageSize
    }
    return this.http.get<any[]>(`${baseUrl}/executive-teams/details?xaxisStartDate=${xAxisStart}&xaxisEndDate=${xAxisEnd}&teamId=${teamId}&widgetEnum=${widgetEnum}`, {params});
  }

  getCoverageData(xaxisStartDate?: string, xaxisEndDate?: string, teamId?: string,widgetEnum?: string, selectedFilters?:any, sortedBy?: any, sortedOrder?: any,page? :any, pageSize?:any): Observable<any> {
    const body = {
      xaxisStartDate,
      xaxisEndDate,
      teamId,
      widgetEnum,
      selectedFilters,
      sortedBy,
      sortedOrder,
      page,
      pageSize
    };
    return this.http.post<any>(`${baseUrl}/executive-teams/details`, body, { headers });
  }

  updateCreationDate(analysisKey: string, creationDate: number) {
    return this.http.put(`${secondUrl}/qwiser/analysis/${analysisKey}/creationDate?creationDate=${creationDate}`,
      {}
    );
  }

}
